import { useRestaurant } from '@local/do-secundo-restaurant-provider'
import { formatCurrency } from '@toasttab/buffet-pui-number-utilities'
import { useMemo } from 'react'

export interface CurrencyFormatterOptions {
  showLeadingSign?: boolean
  truncateZeroCents?: boolean
  renderWhenZero?: string
}

export type CurrencyFormatter = (
  amount: number | undefined,
  options?: CurrencyFormatterOptions
) => string

interface UseCurrency {
  currencyFormatter: CurrencyFormatter
}

export const useCurrency = (): UseCurrency => {
  const { currency, locale } = useRestaurant()

  const currencyFormatter = useMemo(
    () =>
      (amount: number = 0, options?: CurrencyFormatterOptions): string => {
        if (!currency || !locale) return ''
        if (!amount && options?.renderWhenZero !== undefined) {
          return options.renderWhenZero
        }
        let leadingSign = ''
        if (options?.showLeadingSign && amount >= 0) {
          leadingSign = '+'
        }
        let formatOptions: any = { trailingZeros: true }
        if (options?.truncateZeroCents && amount % 1 === 0) {
          formatOptions = {
            ...formatOptions,
            minimumFractionDigits: 0,
            maximumFractionDigits: 0
          }
        }
        const formatted = formatCurrency(
          { amount, currency },
          locale,
          formatOptions
        )
        return leadingSign + formatted
      },
    [currency, locale]
  )

  return { currencyFormatter }
}
